import { Container, Button, Form } from "react-bootstrap";
import { RiCalendarLine, RiFilterLine, RiDownloadLine } from "react-icons/ri";
import EntryStats from "../../components/entryExit/EntryStats";
import EntryFilters from "../../components/entryExit/EntryFilters";
import EntryTable from "../../components/entryExit/EntryTable";
import { useEffect, useState } from "react";
import { getEntryExitActivity, getVehicleAnalyticsApi } from "../../services/Networkcall";
import { errorAlert } from "../../components/common/Alert";
import { Loader } from "../../components/common/Loader";


export default function EntryExit() {
  const [loading, setLoading] = useState(true);
  const [activityData, setActivityData] = useState([]);
  const [vehicleAnalytics, setVehicleAnalytics] = useState([]);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    totalPages: 0,
    totalRecords: 0,
  });
  const [filters, setFilters] = useState({
    search: "",
    startDate: "",
    activity: "",
    yard: "",
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(filters.search);
    }, 800);
    return () => clearTimeout(timer);
  }, [filters.search]);

  const fetchEntryExitData = async () => {
    setLoading(true);
    try {
      const payload = {
        page: pagination.page,
        limit: pagination.limit,
        search: debouncedSearch,
        activity: filters.activity,
        locationId: filters.yard,
        startDate: filters.startDate ? new Date(filters.startDate).toISOString() : "",
      };
      const res = await getEntryExitActivity(payload);
      if (res?.success) {
        setActivityData(res.data);

        setPagination((prev) => ({
          ...prev,
          totalPages: res.totalPages,
          totalRecords: res.totalRecords,
        }));
      } else {
        errorAlert({
          message: res?.message || "Failed to fetch entry/exit data.",
        });
      }
    } catch (err) {
      console.error(err);
      errorAlert({message: err?.response?.data?.message || err?.message || "An error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchVehicleAnalytics = async () => {
    setLoading(true);
    try {
      const res = await getVehicleAnalyticsApi();
      if (res?.success) {
        setVehicleAnalytics(res?.data || [])
      } else {
        errorAlert({message:res?.message || "Failed to fetch records."})
      }
    } catch(err) {
      errorAlert({message: err?.response?.data?.message || err?.message || "Something went wrong."});
    } finally {
      setLoading(false);
    }
  }

  const pageHandler = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  useEffect(() => {
    fetchEntryExitData();
  }, [
    pagination.page,
    pagination.limit,
    debouncedSearch,
    filters.activity,
    filters.yard,
    filters.startDate,
  ]);

  useEffect(() => {
    setPagination((prev) => prev.page === 1 ? prev : { ...prev, page: 1, });
  }, [debouncedSearch, filters.activity, filters.yard, filters.startDate,]);

  useEffect(() => {
    fetchVehicleAnalytics();
  },[])

  return (<>
    <Loader show={loading} />
    <Container fluid className="ee-page vh-100 overflow-scroll">

      <div className="ee-header d-flex justify-content-between align-items-center">

        <div>
          <h3>Entry & Exit Activity</h3>
          <p>Track all yard entries and exits in real time.</p>
        </div>

        <div className="ee-header-actions">

          {/* <Form.Control
            type="text"
            value="04/17/2025 - 04/24/2025"
            className="date-input"
          />

          <Button variant="light">
            <RiFilterLine /> Filters
          </Button>

          <Button variant="light">
            <RiDownloadLine /> Export
          </Button> */}

        </div>

      </div>

      <EntryStats analytics={ vehicleAnalytics} />
      <EntryFilters filters={filters} setFilters={setFilters} />
      <EntryTable entryExitData={activityData} pagination={pagination} pageHandler={pageHandler} />

    </Container>
  </>
  );
}